import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Error } from './styles'
import messages from './messages'

export type FormErrorMessageType = keyof typeof messages

interface IFormMessage {
  errors: {
    id: string
    values?: { [key: string]: string | number }
  }[]
}

const FormErrorMessage = ({ errors = [] }: IFormMessage) => {
  return (
    <>
      {errors.map(error => {
        const message = messages[error.id as FormErrorMessageType]
        return (
          <Error key={error.id} data-testid={error.id}>
            <FormattedMessage {...message} values={error.values} />
          </Error>
        )
      })}
    </>
  )
}

export default FormErrorMessage
